import React from 'react';
import styles from './eipSection.scss';
import { Question } from '../EventTypes';

interface Props {
  questions?: Question[] | null;
}

export const QuestionsComponent: React.FC<Props> = ({ questions }) => {
  if (!questions || !questions?.length) {
    return null;
  }
  return (
    <>
      {questions.map(q => {
        let optionsCount;
        if (q.answerType === 'Option') {
          optionsCount = q?.options?.length;
        }

        return (
          <div className={styles.question}>
            {q?.text} {optionsCount && `(${optionsCount} options)`}
          </div>
        );
      })}
    </>
  );
};
